/* import __COLOCATED_TEMPLATE__ from './sh-infinite-scroll.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';

const OBSERVER_OPTIONS = {
  root: null,
  rootMargin: '250px',
  threshold: 0,
};

class ShInfiniteScroll extends Component {
  #observer = null;

  @action
  observeElement(element) {
    this.#observer ??= new IntersectionObserver(([{ isIntersecting }]) => {
      if (isIntersecting) {
        this.loadNextPage.perform();
      }
    }, OBSERVER_OPTIONS);

    this.#observer.observe(element);
  }

  @action
  unobserveElement() {
    this.#observer?.disconnect();
  }

  @dropTask
  *loadNextPage() {
    yield this.args.loadNextPage();
  }
}

export default ShInfiniteScroll;
